// One toast at a time, optionally with an action (Undo).
import { signal } from './signal.ts';

export interface Toast {
  id: number;
  text: string;
  action?: { label: string; run: () => void };
  error?: boolean;
}

export const toast = signal<Toast | null>(null);
let seq = 0;
let timer: ReturnType<typeof setTimeout> | undefined;

export function show(text: string, opts: { action?: Toast['action']; error?: boolean; ms?: number } = {}): void {
  clearTimeout(timer);
  const t = { id: ++seq, text, ...opts };
  toast.set(t);
  timer = setTimeout(() => toast.get()?.id === t.id && toast.set(null), opts.ms ?? (opts.action ? 8000 : 3500));
}

export const showError = (e: unknown) => show(e instanceof Error ? e.message : String(e), { error: true, ms: 6000 });
